import { render, staticRenderFns } from "./TabLinks.vue?vue&type=template&id=0507412a&scoped=true&"
import script from "./TabLinks.vue?vue&type=script&lang=js&"
export * from "./TabLinks.vue?vue&type=script&lang=js&"
import style0 from "./TabLinks.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabLinks.vue?vue&type=style&index=1&id=0507412a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507412a",
  null
  
)

export default component.exports